import React, {useEffect, useState} from 'react';
import './App.css';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import {getAnalytics} from "firebase/analytics";
import {AuthProvider} from "./utils/AuthProvider";
import '@fontsource/inter';
import {Box, Button, CssBaseline, CssVarsProvider, extendTheme, Sheet, Stack, Typography} from "@mui/joy";
import {Router} from "./utils/Router";
import {FeedbackProvider} from "./utils/FeedbackContext";
import {isMobileDevice, projectTitle} from "./utils/Utils";
import {Check, ContentCopy, DesktopWindows} from "@mui/icons-material";

if (!firebase.apps.length) {
  const app = firebase.initializeApp({
    apiKey: "AIzaSyBScotiAZvC2SQ7YeDGARiy4aMiBKgqxhc",
    authDomain: "oasionthestreet.firebaseapp.com",
    projectId: "oasionthestreet",
    storageBucket: "oasionthestreet.firebasestorage.app",
    messagingSenderId: "947463761447",
    appId: "1:947463761447:web:94d2f4d5f1ba8decc42802",
    measurementId: "G-C7MXKST8N3"
  })
  getAnalytics(app);
}

const baseTheme = extendTheme();
const darkOnlyTheme = extendTheme({
  cssVarPrefix: "sidebar_",
  colorSchemes: {
    light: baseTheme.colorSchemes.light,
    dark: baseTheme.colorSchemes.dark,
  },
});

function App() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMobile(isMobileDevice())
    console.info('\x1b[34m%s\x1b[0m', // \x1b[38;5;33m
        "\n\n" +
        "        Developed with <3 by\n" +
        "        DANIELE DI GREGORIO\n" +
        "      www.danieledigregorio.it\n")
  }, []);

  return (
      <div>
        <AuthProvider>
          <FeedbackProvider>
            <CssVarsProvider theme={darkOnlyTheme} defaultMode="light">
              <CssBaseline />
              <Box sx={{
                minHeight: '100%',
                maxWidth: '100vw',
                backgroundColor: "var(--joy-palette-background-body)",
              }}
              >
                {
                  isMobile ?
                      <MobileDeviceError />
                      :
                      <Router />
                }
              </Box>
            </CssVarsProvider>
          </FeedbackProvider>
        </AuthProvider>
      </div>
  );
}

export default App;


function MobileDeviceError() {
  const [copied, setCopied] = useState(false)
  const url = typeof window !== "undefined" ? window.location.origin : ""

  function copyUrl() {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }).catch(() => {})
  }

  return (
      <Stack
          justifyContent="center"
          alignItems="center"
          sx={{
            height: "100dvh",
            p: 3,
            background: "linear-gradient(180deg, var(--joy-palette-primary-50) 0%, var(--joy-palette-background-body) 55%)",
          }}
      >
        <Sheet
            variant="outlined"
            sx={{
              maxWidth: 420,
              width: "100%",
              borderRadius: "xl",
              p: 4,
              textAlign: "center",
              boxShadow: "md",
            }}
        >
          <Box
              sx={{
                width: 72,
                height: 72,
                mx: "auto",
                mb: 2,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "primary.100",
                color: "primary.600",
              }}
          >
            <DesktopWindows sx={{fontSize: 36}}/>
          </Box>

          <Typography level="h3" sx={{mb: 1}}>
            Passa al desktop
          </Typography>

          <Typography level="body-md" sx={{color: "text.secondary", mb: 3}}>
            {projectTitle} è un pannello di amministrazione pensato per schermi grandi. Apri questo link da
            computer per continuare.
          </Typography>

          {
            url !== "" &&
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
              <Sheet
                  variant="soft"
                  color="neutral"
                  sx={{px: 1.5, py: 0.75, borderRadius: "md", overflow: "hidden"}}
              >
                <Typography level="body-sm" noWrap sx={{fontFamily: "monospace"}}>
                  {url}
                </Typography>
              </Sheet>
              <Button
                  size="sm"
                  variant={copied ? "solid" : "outlined"}
                  color={copied ? "success" : "neutral"}
                  startDecorator={copied ? <Check/> : <ContentCopy/>}
                  onClick={copyUrl}
              >
                {copied ? "Copiato" : "Copia"}
              </Button>
            </Stack>
          }
        </Sheet>
      </Stack>
  )
}